import { render, staticRenderFns } from "./HomeLawMasterAiShare.vue?vue&type=template&id=1f25b8ac&scoped=true"
import script from "./HomeLawMasterAiShare.vue?vue&type=script&lang=js"
export * from "./HomeLawMasterAiShare.vue?vue&type=script&lang=js"
import style0 from "./HomeLawMasterAiShare.vue?vue&type=style&index=0&id=1f25b8ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f25b8ac",
  null
  
)

export default component.exports